import SignupModal from "./SignUpModak"; // Corrected typo in import
import React, { useState, useEffect } from "react";
import LoginModal from "./LoginModal";
import "../styles/Navbar.css";
import { useNavigate, useLocation } from "react-router-dom"; // Import useLocation to get the current path
import { BsPersonCircle} from "react-icons/bs";
import { BsWhatsapp } from "react-icons/bs";


const Navbar = () => {
    const [showSignupModal, setShowSignupModal] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate();
    const location = useLocation(); // Get the current path

    // Check if the user is logged in on component mount
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            setIsLoggedIn(true);
        }
    }, []);

    // Handle logout
    const handleLogout = () => {
        localStorage.removeItem("token"); // Remove the token
        setIsLoggedIn(false); // Update state to reflect logged out status
        navigate("/"); // Redirect to home page
        window.location.reload();
    };

    // Handle redirection to home page ("/")
    const redirectToHome = () => {
        navigate("/"); // Redirect to the home page
    };

    // Conditionally render "Home" button only if the current route is not "/"
    const showHomeButton = location.pathname !== "/";

    return (
        <>
            <nav className="navbar">
                

                <div className="navbar-logo-container">
                    <img src="/assets/logo.jpg" alt="Level Logo" className="navbar-logo" />
                    <span className="beta-badge">Beta</span>
                </div>


                <div className="auth-buttons">

                    <button
                        onClick={() => window.open("https://chat.whatsapp.com/G41M1FAlmHs3bY3L6JdGq8", "_blank")}
                        className="auth-button whatsapp-button"
                        title="Join our WhatsApp Group"
                    >
                        <BsWhatsapp style={{ marginRight: "8px", fontSize: "20px" }} />
                        Group
                    </button>

                    {/* Show Home button next to logout only if the user is logged in */}
                          
                    {showHomeButton && (
                        <button onClick={redirectToHome} className="auth-button">
                            🏠 Games
                        </button>
                    )}
            
                    {isLoggedIn && (
                      <button onClick={handleLogout} className="auth-button"><BsPersonCircle style={{marginRight: "8px", fontSize:"22px"}}/>Logout</button>
                    )}

                    {/* Show Home button next to logout only if not on the home page */}
                    

                    {/* Show sign in and sign up buttons only if not logged in */}
                    {!isLoggedIn && (
                        <>
                            {/* <button onClick={() => setShowLoginModal(true)} className="auth-button"> <BsPersonCircle style={{marginRight: "8px", fontSize:"20px"}}/>Sign in</button> */}
                            {/* <button onClick={() => setShowSignupModal(true)} className="auth-button">Sign up</button> */}
                      </>
                    )}
                </div>
            </nav>


            {showSignupModal && (
                <SignupModal
                    onClose={() => setShowSignupModal(false)}
                    onSignupSuccess={() => {
                        setShowSignupModal(false); // Close Signup Modal
                        setShowLoginModal(true); // Open Login Modal
                    }}
                />
            )}

            {showLoginModal && (
                <LoginModal
                    onClose={() => setShowLoginModal(false)}
                    onShowSignup={() => {
                        setShowLoginModal(false); // Close Login Modal
                        setShowSignupModal(true); // Open Signup Modal
                    }}
                    onLoginSuccess={() => {
                        setShowLoginModal(false); // Close Login Modal
                        setIsLoggedIn(true); // Update state to reflect logged in status
                    }}
                />
            )}
        </>
    );
};

export default Navbar;
